import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/estetik-islemlerin-etkisini-azaltan-hastaliklar/page.tsx");
